import React from "react";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink border-t border-warm-border"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-5">
          <span className="font-serif text-parchment text-2xl tracking-wider">
            Sirah Nabawiyah
          </span>
          <p className="mt-3 text-sm text-warm-muted leading-relaxed max-w-md font-light">
            Sebuah upaya editorial untuk merangkum perjalanan Rasulullah ﷺ —
            disusun dengan kasih, untuk kita pelajari bersama.
          </p>
        </div>

        <div className="md:col-span-3">
          <span className="block text-[10px] uppercase tracking-[0.3em] text-copper mb-3">
            Linimasa
          </span>
          <ul className="space-y-2 text-sm text-warm-muted">
            <li>
              <a href="#fase-571" className="hover:text-parchment transition">
                571 — Pra-Kenabian
              </a>
            </li>
            <li>
              <a href="#fase-610" className="hover:text-parchment transition">
                610 — Kenabian
              </a>
            </li>
            <li>
              <a href="#fase-1H" className="hover:text-parchment transition">
                1 H — Hijrah
              </a>
            </li>
            <li>
              <a href="#fase-FATHU" className="hover:text-parchment transition">
                Fathu Makkah
              </a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-4 md:text-right">
          <span className="block text-[10px] uppercase tracking-[0.3em] text-copper mb-3">
            Catatan
          </span>
          <p className="text-sm text-warm-muted leading-relaxed font-light">
            Disusun berdasarkan rangkuman sejarah klasik. Untuk kajian
            mendalam, kita selalu kembali kepada Al-Qur'an dan Sunnah.
          </p>
        </div>
      </div>

      <div className="border-t border-warm-border">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col md:flex-row gap-3 md:items-center md:justify-between text-[11px] uppercase tracking-[0.25em] text-warm-muted">
          <span>© {new Date().getFullYear()} — Editorial Storytelling</span>
          <span>Dibangun untuk mengingat, bukan sekadar mengetahui</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
